// websiteLeads.ts — Patch 014.3. Website lead-capture staff methods.
//
// The public POST /api/public/website-leads is the website's surface, not
// the staff app's — these are the triage routes. See workers/core-os/src/
// routes/website_leads.ts.

import { request } from './request'
import type {
  PatchWebsiteLeadInput,
  WebsiteLeadListResponse,
} from './types'

export const websiteLeadsApi = {
  list: (params?: { status?: string }) => {
    const qs = new URLSearchParams()
    if (params?.status) qs.set('status', params.status)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return request<WebsiteLeadListResponse>(`/api/website-leads${suffix}`)
  },
  update: (id: string, body: PatchWebsiteLeadInput) =>
    request<{
      ok: true
      id: string
      status: string
      profile_id: string | null
      created_profile: boolean
    }>(`/api/website-leads/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
}
